import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Col, Container, Row, Visible } from "react-grid-system"
import { Fade } from "react-reveal"
import { StyledBigHeaderH2, StyledParagraphSmall } from "../Typography"
import styled from "styled-components"
import { breakpoint } from "../../utils/breakpoint"

const StyledSectionWrapper = styled.section`
  position: relative;
  z-index: 3;
  overflow-x: hidden;
  margin-bottom: 10%;
`

const StyledBigHeaderWrapperDesktop = styled.div`
  margin-bottom: 30px;

  ${breakpoint.lg} {
    margin-bottom: 80px;
  }
`

const PortfolioCompaniesSection = () => {
  return (
    <>
      <Visible xs sm md>
        <StyledSectionWrapper>
          <Container fluid>
            <Row align="center">
              <Col xs={12}>
                <Fade ssrReveal left>
                  <StyledBigHeaderH2 style={{ marginBottom: "20px" }}>
                    Our
                    <br /> Portfolio
                    <br /> Companies
                  </StyledBigHeaderH2>
                </Fade>
              </Col>
              <Col xs={12}>
                <Fade ssrReveal left>
                  <StyledParagraphSmall>
                    In the first year of our journey, we have made significant
                    progress in building a diverse portfolio of companies across
                    Asia that help advance our mission - driving change in line
                    with the United Nations Sustainable Development Goals.
                  </StyledParagraphSmall>
                  <StyledParagraphSmall>
                    We have added five companies to our portfolio over the past
                    12 months, investing across our five themes –{" "}
                    <span style={{ fontWeight: 700 }}>
                      Climate & Water Solutions, Better Healthcare & Education,
                      Sustainable Food & Agriculture, Financial & Digital
                      Inclusion and Smart & Liveable Cities.
                    </span>{" "}
                    We take pride in the impact these companies are creating for
                    the environment and our society.
                  </StyledParagraphSmall>
                </Fade>
              </Col>
              <Col xs={12}>
                <Fade ssrReveal right>
                  <div style={{ marginTop: "15px" }}>
                    <StaticImage
                      src="../../images/17-icons-with-logo.png"
                      alt="17 SDGs"
                      layout="fullWidth"
                      quality={95}
                    />
                  </div>
                </Fade>
              </Col>
            </Row>
          </Container>
        </StyledSectionWrapper>
      </Visible>

      <Visible lg xl xxl>
        <section
          style={{ position: "relative", zIndex: 3, overflowX: "hidden" }}
        >
          <Container>
            <Row align="stretch" style={{ marginBottom: "30px" }}>
              <Col xs={12} lg={6} xxl={5}>
                <Fade ssrReveal left>
                  <StyledBigHeaderWrapperDesktop>
                    <StyledBigHeaderH2>
                      Our
                      <br /> Portfolio
                      <br /> Companies
                    </StyledBigHeaderH2>
                  </StyledBigHeaderWrapperDesktop>
                  <StyledParagraphSmall>
                    In the first year of our journey, we have made significant
                    progress in building a diverse portfolio of companies across
                    Asia that help advance our mission - driving change in line
                    with the United Nations Sustainable Development Goals.
                  </StyledParagraphSmall>
                  <StyledParagraphSmall>
                    We have added five companies to our portfolio over the past
                    12 months, investing across our five themes –{" "}
                    <span style={{ fontWeight: 700 }}>
                      Climate & Water Solutions, Better Healthcare & Education,
                      Sustainable Food & Agriculture, Financial & Digital
                      Inclusion and Smart & Liveable Cities.
                    </span>{" "}
                    We take pride in the impact these companies are creating for
                    the environment and our society.
                  </StyledParagraphSmall>
                </Fade>
              </Col>
              <Col xs={12} lg={6} xl={5} offset={{ xl: 1, xxl: 2 }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <Fade ssrReveal right>
                    <div style={{ textAlign: "right" }}>
                      <StaticImage
                        src="../../images/17-icons-with-logo.png"
                        alt="17 SDGs"
                        layout="fullWidth"
                        quality={95}
                      />
                    </div>
                  </Fade>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <Fade ssrReveal right></Fade>
              </Col>
            </Row>
          </Container>
        </section>
      </Visible>
    </>
  )
}

export default PortfolioCompaniesSection
